import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

/**
 * Shown over a pane while copy mode is on (card 3): what mode this is and
 * the keys that matter, as tmux shows its position and WezTerm its mode.
 */
export default function CopyModeBadge({ onExit }) {
  const { t } = useTranslation();
  const keys = [
    ['hjkl ←↑↓→', t('terminalExt.copyModeMove', 'move')],
    ['w b', t('terminalExt.copyModeWord', 'word')],
    ['v V', t('terminalExt.copyModeSelect', 'select')],
    ['y', t('terminalExt.copyModeCopy', 'copy')],
    ['Esc', t('terminalExt.copyModeExit', 'exit')],
  ];
  return (
    <div className="term-copy-badge" role="status" aria-label={t('terminalExt.copyMode', 'Copy mode')}>
      <span className="term-copy-badge-title">{t('terminalExt.copyMode', 'Copy mode')}</span>
      {keys.map(([k, label]) => (
        <span key={k} className="term-copy-badge-key">
          <kbd>{k}</kbd> {label}
        </span>
      ))}
      <button
        type="button"
        className="term-search-btn"
        aria-label={t('terminalExt.copyModeLeave', 'Leave copy mode')}
        title={t('terminalExt.copyModeLeave', 'Leave copy mode')}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onExit}
      >
        <X size={14} />
      </button>
    </div>
  );
}
